export const environment = {
  version: '9.3.0',
  production: false,
  sentryDsn: 'https://9d7bcbf13263939d931c5312023e152a@o4506308503273472.ingest.sentry.io/4506465916157952',
  restAPI: 'https://api.calenso.io/api/v1/',
  bookingWebcomponentUrl: 'https://webcomponent.calenso.io/booking.html',
  hostName: 'https://api.calenso.io',
  calioDashboardBaseUrl: 'https://dashboard.calenso.io',
  imageHostName: 'https://my.calenso.com',
  workerAvatarBaseUrl: 'https://api.calenso.io/webroot/files/workers/avatar/',
  storeBaseUrl: 'https://api.calenso.io/webroot/files/stores/logo/',
  deployUrl: 'https://smartwidget.calenso.io/',
  stripe: {
    publishableKey: 'pk_test_qC6Q2zbwLgHgHEzXkHdKATbR',
  },
  encryptedKey: '6LfB5EchAAAAAMiJapMV9GumBAQBfKqboRWT5she',
  brandName: 'Calenso',
  brandUrls: {
    BRAND_TERMS_URL: 'https://www.calenso.com/agb/',
    BRAND_PRIVACY_URL: 'https://www.calenso.com/datenschutz/',
  },
  bookingElementName: 'calenso-booking',
  smartWidgetElementTag: 'calenso-smart-widget',
  defaultLocale: 'de_CH',
};
